import { CalendarOutlined } from '@ant-design/icons'
import { Timeline, Tooltip, Typography } from 'antd'
import { sortBy } from 'lodash'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { MosaicComponent, getPointPermission } from '@/components'
import { routes } from '@/router'
import { PAGE_RESOURCE_POINTS_ENUM, Project } from '@/schemas'

const { Text } = Typography

interface ProjectStagesProps {
  project: Project
}

export const ProjectStages: React.FC<ProjectStagesProps> = ({ project }) => {
  const { t } = useTranslation()
  let { projectStages: stages } = project
  const { canCreate, canRead } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.阶段与任务, project.permissions)

  if (stages && stages.length === 0 && canRead) {
    return canCreate ? (
      <Link className='text-xs' to={routes.project.page(project.selfId, { tab: 'stage' })}>
        {t('stage.add')}
      </Link>
    ) : (
      <Typography.Text type='secondary'>无阶段</Typography.Text>
    )
  }

  stages = (stages || []).slice().reverse()

  const timeline = (
    <div className='max-h-55vh overflow-auto pt-4px mb-4px'>
      <Timeline>
        {stages.map((s) => (
          <Timeline.Item key={s.id} color={{ 0: 'gray', 1: 'blue', 2: 'green', 3: 'red' }[s.status]}>
            <div>{s.name || s.description}</div>
            <Tooltip title={t('actual end date')}>
              <Text type='secondary' className='text-xs'>
                {s.description}
                {s.actualEndDate ? ' · ' + moment(s.actualEndDate).format('l') : null}
              </Text>
            </Tooltip>
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  )

  const planEndDateItem = sortBy(stages, (s) => !s.planEndDate)[0]
  const planStartDateItem = sortBy(stages, 'planStartDate')[0]

  if (!canRead) return <MosaicComponent />

  return (
    <div>
      <Text type={planEndDateItem?.planEndDate ? 'secondary' : 'danger'} className='block mb-16px'>
        <CalendarOutlined className='mr-12px' />
        {t('plan end date')}：{planEndDateItem?.planEndDate ? moment(planEndDateItem.planEndDate).format('l') : t('无')}
      </Text>
      {timeline}
      <Text type={planStartDateItem?.planStartDate ? 'secondary' : 'danger'}>
        <CalendarOutlined className='mr-12px' />
        {t('plan start date')}：
        {planStartDateItem?.planStartDate ? moment(planStartDateItem.planStartDate).format('l') : t('无')}
      </Text>
    </div>
  )
}
